class window.D12Map
    self = undefined
    canvas = undefined
    drawCtx = undefined

    territoryAdjacenciesDrawn = false

    constructor: (mapID, width, height) ->
        self = this

        @mapID = mapID
        @width = width
        @height = height
        @initializeDrawContext()

    initializeDrawContext: () ->
        map = $('#map')
        map.prepend('<canvas id="map-canvas"></canvas>')
        @canvas = map.find('#map-canvas')
        @canvas.css('position', 'absolute')
        @canvas.css('top', 0)
        @canvas.css('left', 0)
        @canvas[0].width = self.width
        @canvas[0].height = self.height
        @drawCtx = @canvas[0].getContext("2d")

    setMapSize: (size, factor, offX = 0, offY = 0) ->
        $('[data-territory]').each(() ->
            parent = $(this).parent()

            # Change positions
            parent.css('left', factor * $(this).data('x') + offX)
            parent.css('top', factor * $(this).data('y') + offY)

            # Change territory circle class
            parent.removeClass((index, css) ->
                (css.match(/(^|\s)territory-\S+/g) or []).join(' ')
            )
            parent.addClass("territory-#{size}")
        )

        # Change background
        map = $('#map')
        map.css('background-image', "url('#{baseurl}/assets/img/maps/#{self.mapID}.#{size}.jpg')")
        map.css('width', self.width * factor)
        map.css('height', self.height * factor)
        self.canvas.css('width', self.width * factor)
        self.canvas.css('height', self.height * factor)

        @updateTerritoryAdjacencyDrawing()

    setMapSizeLarge: () ->
        @setMapSize('large', 1)

    setMapSizeSmall: () ->
        @setMapSize('small', 0.75, -1, -1)

    setTerritoryAdjacenciesDrawn: (isDrawn) ->
        @territoryAdjacenciesDrawn = isDrawn
        @updateTerritoryAdjacencyDrawing()

    updateTerritoryAdjacencyDrawing: () ->
        @drawCtx.clearRect(0, 0, @canvas.width(), @canvas.height())

        if not @territoryAdjacenciesDrawn
            return

        $('[data-territory]').each(() ->
            id = parseInt($(this).data('territory'), 10)
            adjacencies = $(this).attr('data-adjacencies')
                .split(',')
                .map((adj) -> parseInt(adj, 10))
            x = parseInt($(this).data('x'), 10)
            y = parseInt($(this).data('y'), 10)
            offsetX = $(this).parent().width() / 2
            offsetY = $(this).parent().height() / 2

            adjacencies.forEach((adj) ->
                if isNaN(adj)
                    return

                other = $("#territory-#{adj}")
                otherX = parseInt(other.data('x'), 10)
                otherY = parseInt(other.data('y'), 10)

                self.drawCtx.beginPath()
                self.drawCtx.moveTo(x + offsetX, y + offsetY)
                self.drawCtx.lineTo(otherX + offsetX, otherY + offsetY)
                self.drawCtx.stroke()
            )
        )
